import { createSelector } from 'reselect'

const getArtists = state => state.artists

const defaultDisciplineLabel = 'Other'

const getDisciplineLabel = (artist, disciplineId) => {
  if (disciplineId === null || typeof disciplineId === 'undefined') return defaultDisciplineLabel

  const embedded = artist.get('_embedded')
  if (embedded) {
    return embedded.get('wp:term').first().find(o => {
      return o.get('id') === disciplineId
    }).get('name')
  }

  return defaultDisciplineLabel
}

export const getArtistEnabled = createSelector(
  [getArtists],
  artists => artists.get('enabled')
)

export const getArtistList = createSelector(
  [getArtists],
  artists => {
    // Artists data { artists: Array, order: { acf: { discipline_order, artist_order }}}
    const data = artists.get('data')

    if (data) {
      const artistList = data.get('artists')
      const artistOrder = data.get('order').get('acf').get('artist_order')

      const orderedList = []
      artistOrder.forEach(order => {
        const artist = artistList.find(artist => artist.get('id') === order)
        if (artist) {
          orderedList.push(artist)
        } else {
          // artist has not been added inside ordering module
        }
      })

      const groupBy = (xs, key) => {
        return xs.reduce((prev, curr) => {
          // Skip if no discipline
          if (!curr[key]) return prev
          // Create or use existing group
          prev[curr[key]] = prev[curr[key]] || []
          // Push to group
          prev[curr[key]].push(curr)
          return prev
        }, {})
      }

      const list = orderedList.map(artist => ({
        id: artist.get('id'),
        title: artist.get('title').get('rendered'),
        slug: artist.get('slug'),
        acf: artist.get('acf'),
        disciplineId: artist.get('discipline') ? artist.get('discipline').first() : null,
        disciplineLabel: getDisciplineLabel(artist, artist.get('discipline') && artist.get('discipline').first())
      }))

      return groupBy(list, 'disciplineLabel')
    }

    return data
  }
)



// WEBPACK FOOTER //
// ./src/components/artist-list-container/selectors.js